import React from 'react'
import ExperienceSearchPageFilters from './ExperienceSearchPageFilters'
import TextButton from 'LuxKit/Button/TextButton'
import FilterPanelFilterGroup from 'components/Common/FilterPanel/FilterPanelFilterGroup'
import ExperiencesSortByOptions from './ExperiencesSortByOptions'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'

interface Props {
  open?: boolean
  onClose?: () => void
  placeId: string
}

function ExperienceSearchPageFiltersSidebar(props: Props) {
  const {
    open,
    onClose,
    placeId,
  } = props

  return (
    <ModalBase
      mode="drawer"
      isOpen={open}
      onClose={onClose}
    >
      <ModalHeader
        title="Sort & filter"
        onCloseButtonClick={onClose}
      />
      <ModalBody>
        <ModalContent>
          <FilterPanelFilterGroup title="Sort by">
            <ExperiencesSortByOptions />
          </FilterPanelFilterGroup>
          <ExperienceSearchPageFilters
            placeId={placeId}
          />
        </ModalContent>
      </ModalBody>
      <ModalFooter>
        <TextButton kind="primary" onClick={onClose} fit="full-width">
          Apply
        </TextButton>
      </ModalFooter>
    </ModalBase>
  )
}

export default ExperienceSearchPageFiltersSidebar
